export const UNLOAD_DOCUMENTS = 'UNLOAD_DOCUMENTS';
export const REMOVE_DOCUMENT_FROM_LIST = 'REMOVE_DOCUMENT_FROM_LIST';

export function unloadDocuments() {
    return dispatch => dispatch(unloadDocumentsAction());
}

export function unloadDocumentsAction() {
    return {
        type: UNLOAD_DOCUMENTS,
        payload: {}
    };
}

export function removeDocumentFromList(documentId) {
    return dispatch => dispatch(removeDocumentFromListAction(documentId));
}

export function removeDocumentFromListAction(documentId) {
    return {
        type: REMOVE_DOCUMENT_FROM_LIST,
        payload: {documentId}
    };
}